import classnames from 'classnames';
import React, { MouseEvent, ReactNode } from 'react';

import { getClassNames, ButtonCommonProps } from '@/shared/components/button/Button';
import Analytics from '@/shared/utils/analytics/analytics';

type Props = ButtonCommonProps & {
  href?: string;
  target?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  children: ReactNode;
  className?: string;
};

export default function ButtonLink({
  variant,
  icon,
  large,
  disabled,
  loading,
  className,
  ...rest
}: Props) {
  const onClick = () => {
    Analytics.getInstance().logEvent('CLICKED_LINK', { target: rest.href }, 'previewQueue');
  };

  return (
    <a
      className={classnames(getClassNames({ variant, icon, large, disabled, loading }), className)}
      onClick={onClick}
      style={icon ? { backgroundImage: `url(${icon})` } : {}}
      {...rest}
    />
  );
}
